import React from "react";

// Text label for an event's state, so the card never relies on its shadow
// colour alone.
export const FEED_LABELS = {
  today: "Happening now",
  open: "Registration open",
  late: "Closed · late entries open",
  upcoming: "Coming soon",
  closed: "Registration closed",
  results: "Results",
  entered: "Entered",
};

const FeedPill = ({ state }) =>
  FEED_LABELS[state] ? (
    <span className={`feed-pill feed-pill--${state}`}>{FEED_LABELS[state]}</span>
  ) : null;

export default FeedPill;
